import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "team-member-card d-flex flex-column rounded-sm gr-2 pa-6 cursor-pointer",
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _vm.adminkaUrl
        ? _c(
            "a",
            {
              staticClass: "adminka align-self-start",
              attrs: {
                href: _vm.adminkaUrl,
                target: "_blank",
                rel: "noopener noreferrer",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_vm._v("править")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "text-body-1 text--text" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.transDynamic(
                _vm.teamMember,
                `first_name,${_setup.language},${_setup.needTranslate}`
              )
            ) +
            "\n    " +
            _vm._s(
              _setup.transDynamic(
                _vm.teamMember,
                `last_name,${_setup.language},${_setup.needTranslate}`
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-body-2 text--text" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.transDynamic(
                _vm.teamMember,
                `position,${_setup.language},${_setup.needTranslate}`
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(VImg, {
        staticClass: "flex-grow-0 mt-auto rounded-circle",
        attrs: {
          "lazy-src": "/static/_v1/pd/pictures/stubs/person-photo.png",
          alt: `${_setup.transDynamic(
            _vm.teamMember,
            `first_name,${_setup.language},${_setup.needTranslate}`
          )} ${_setup.transDynamic(
            _vm.teamMember,
            `last_name,${_setup.language},${_setup.needTranslate}`
          )} ${_setup.transDynamic(
            _vm.teamMember,
            `position,${_setup.language},${_setup.needTranslate}`
          )}`,
          src: _vm.teamMember.photo.url,
          width: "200",
          height: "200",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }